/**
 * Fabrication du texte CSV — la partie PURE de `downloadCsv`, isolée pour être
 * testée sans navigateur.
 *
 * Choix de format : séparateur « ; », fin de ligne CRLF, BOM UTF-8. C'est la
 * combinaison qu'un tableur réglé en français ouvre directement (la virgule y
 * est le séparateur décimal, et sans BOM les accents sortent en mojibake).
 */

const SEPARATOR = ";";
const BOM = "﻿";

/** Lit une valeur par chemin pointé (`a.b.0.c`). */
const getPath = (obj, path) =>
  String(path)
    .split(".")
    .reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);

/** Aplatit une valeur en texte de cellule. */
const cellText = (value) => {
  if (value == null) return "";
  if (Array.isArray(value)) return value.map(cellText).join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

/**
 * Échappe une cellule : guillemets doublés, et cellule entourée de guillemets
 * dès qu'elle contient le séparateur, un guillemet ou un saut de ligne.
 *
 * Une cellule commençant par `=`, `+`, `-` ou `@` est préfixée d'une apostrophe :
 * un tableur l'évaluerait comme une formule, et ces exports contiennent du texte
 * venu de sites tiers (extraits d'éléments, adresses).
 */
export const escapeCsvCell = (value) => {
  let text = cellText(value);
  if (/^[=+\-@]/.test(text) && Number.isNaN(Number(text))) text = `'${text}`;
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/**
 * @param {object[]} rows                      Les lignes.
 * @param {{label?: string, path: string}[]} columns  Les colonnes, dans l'ordre.
 * @returns {string} Le CSV complet, BOM compris.
 */
export const buildCsv = (rows, columns) => {
  const head = columns.map((c) => escapeCsvCell(c.label ?? c.path)).join(SEPARATOR);
  const body = rows.map((row) =>
    columns.map((c) => escapeCsvCell(getPath(row, c.path))).join(SEPARATOR),
  );
  return BOM + [head, ...body].join("\r\n") + "\r\n";
};
